import { useRef } from 'react';

function formatSize(bytes) {
    if (!bytes) return '';
    const units = ['B', 'KB', 'MB', 'GB'];
    let i = 0;
    let n = bytes;
    while (n >= 1024 && i < units.length - 1) { n /= 1024; i++; }
    return `${n.toFixed(n < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
}

/** Selector de archivos a adjuntar antes de enviar, con lista editable. */
export default function AttachmentPicker({ files, onChange }) {
    const inputRef = useRef(null);

    const addFiles = (fileList) => {
        const picked = Array.from(fileList || []);
        if (picked.length === 0) return;
        onChange([...files, ...picked]);
    };

    const removeAt = (index) => {
        onChange(files.filter((_, i) => i !== index));
    };

    return (
        <div className="space-y-2">
            <input
                ref={inputRef}
                type="file"
                multiple
                className="hidden"
                onChange={(e) => { addFiles(e.target.files); e.target.value = ''; }}
            />
            <button
                type="button"
                onClick={() => inputRef.current?.click()}
                className="text-xs font-bold text-gray-500 dark:text-gray-400 hover:text-blue-600 flex items-center gap-1"
            >
                <span className="material-symbols-outlined text-base">attach_file</span> Adjuntar archivos
            </button>

            {files.length > 0 && (
                <div className="flex flex-wrap gap-2">
                    {files.map((file, i) => (
                        <div key={`${file.name}-${i}`} className="flex items-center gap-2 text-xs bg-gray-100 dark:bg-slate-700 px-2.5 py-1.5 rounded-lg">
                            <span className="material-symbols-outlined text-sm text-gray-500">draft</span>
                            <span className="max-w-[160px] truncate dark:text-gray-200" title={file.name}>{file.name}</span>
                            <span className="text-gray-400">{formatSize(file.size)}</span>
                            <button type="button" onClick={() => removeAt(i)} className="text-gray-400 hover:text-red-500">
                                <span className="material-symbols-outlined text-sm">close</span>
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
